import Applications from './Applications';
import { NAME } from './constants';
import reducer from './reducer';
import * as actions from './actions';

export default {
  NAME,
  Applications,
  reducer,
  actions,
};
